import {shareReplay, distinctUntilChanged, map, first} from 'rxjs/operators';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  ViewChild,
} from '@angular/core';
import {APPCONFIG} from '../../config';
import {Observable} from 'rxjs';
import {NavigationBarConfiguration} from '../../cache/uiconfiguration/navigationbarconfiguration';
import {CacheService} from '../../cache/cache.service';
import {Router} from '@angular/router';
import {LayoutService} from '../layout.service';
import {LanguageService} from '../../language/language.service';
import {UIConfiguration} from '../../cache/uiconfiguration/uiconfiguration';

@Component({
  selector: 'my-app-sidenav',
  styleUrls: ['./sidenav.component.scss'],
  templateUrl: './sidenav.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AppSidenavComponent implements OnInit {
  AppConfig;
  navBarConfigs_Footer: Observable<NavigationBarConfiguration[]>;
  navBarConfigs_Main: Observable<NavigationBarConfiguration[]>;

  color: Observable<string>;
  textColor: Observable<string>;
  siteTitle: Observable<string>;

  constructor(
    private cacheService: CacheService,
    private router: Router,
    private layoutService: LayoutService,
    private languageService: LanguageService,
    private changeDetector: ChangeDetectorRef,
  ) {
    this.color = this.cacheService.getUIConfiguration().pipe(
      first(),
      map((uiconf: UIConfiguration) => uiconf.color),
      distinctUntilChanged(),
      shareReplay(1),
    );
    this.textColor = this.cacheService.getUIConfiguration().pipe(
      first(),
      map((uiconf: UIConfiguration) => uiconf.textcolor),
      distinctUntilChanged(),
      shareReplay(1),
    );
    this.siteTitle = this.cacheService.getUIConfiguration().pipe(
      first(),
      map((uiconf: UIConfiguration) => uiconf.sitetitle),
      distinctUntilChanged(),
      shareReplay(1),
    );
  }

  getContent(): void {
    this.navBarConfigs_Footer = this.cacheService
      .getNavigationBarConfigurationsToDisplayFooter()
      .pipe(first());
    this.navBarConfigs_Main = this.cacheService
      .getNavigationBarConfigurationsToDisplayMain()
      .pipe(first());
    this.changeDetector.markForCheck();
  }

  ngOnInit() {
    this.AppConfig = APPCONFIG;
    this.getContent();
  }

  toggleCollapsedNav() {
    this.AppConfig.navCollapsed = !this.AppConfig.navCollapsed;
  }

  formatNumber(value: number): Observable<string> {
    return this.languageService
      .getLanguage(this.cacheService.getSupportedLocaleConfiguration())
      .pipe(
        map((language: string) => {
          if (value != null) {
            return value.toLocaleString(language);
          }
        }),
      );
  }

  openNavBarItem(navBarItem: NavigationBarConfiguration, event: MouseEvent) {
    let link = ['/home'];
    switch (navBarItem.sitetype) {
      case 'list':
      case 'olist':
      case 'create':
        link = ['/' + navBarItem.sitetype, navBarItem.urlid];
        break;
      case 'objectlist':
        link = ['/olist', navBarItem.urlid];
        break;
      case 'administration':
        link = ['/administration'];
        break;
      case 'get':
      case 'timeline':
        if (navBarItem.urlid) {
          link = ['/' + navBarItem.sitetype, navBarItem.urlid];
        } else {
          link = ['/' + navBarItem.sitetype, navBarItem.linkedobject];
        }

        break;
      case 'profile':
        this.cacheService.getCurrentUser().subscribe(usr => {
          link = ['/get', usr.id];
          if (this.router.isActive(link.join('/'), true)) {
            this.layoutService.updateResourceView('get', link[1], link[2]);
          } else {
            this.router.navigate(link);
          }
        });
        return;
      case 'wizard':
        link = ['/wizard', navBarItem.urlid, navBarItem.linkedobject];
        break;
      case 'external':
        window.location.href = navBarItem.urlid;
        return;
      case 'home':
        if (navBarItem.urlid == null) {
          link = ['/home'];
        } else {
          link = ['/home', navBarItem.urlid];
        }
        break;
      default:
        link = ['/home'];
    }

    if (event.ctrlKey || event.button === 1) {
      window.open('#' + link.join('/'));
    } else {
      if ((link.length === 2 || link.length === 3) && this.router.isActive(link.join('/'), true)) {
        this.layoutService.updateResourceView(navBarItem.sitetype, link[1], link[2]);
      } else {
        this.router.navigate(link);
      }
    }
  }
}
